export const tool_data = [
  { name: 'Windows', period: 28, icon: 'devicon-windows11-original' },
  { name: 'Chrome', period: 24, icon: 'devicon-chrome-plain' },
  { name: 'VSC', period: 8, icon: 'devicon-vscode-plain' },
  { name: 'Photoshop', period: 23, icon: 'devicon-photoshop-plain' },
  { name: 'Illustrator', period: 27, icon: 'devicon-illustrator-plain' }
];
